

exports.megAgenceMap = function() {
  "use strict";
  var map;
  var propertiesOverlay = [];
  var propertiesBounds = null;
  return {
    initialize : function(selector) {
      var mapOptions = {
        zoom: 2,
        maxZoom: 12,
        center: new google.maps.LatLng(0, 0),
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        mapTypeControlOptions: {
          mapTypeIds: []
        },
        streetViewControl:false
      };

      map = new google.maps.Map(document.getElementById(selector), mapOptions);
      map.set('styles', [
        {
          "featureType":"water",
          "elementType": "geometry",
          "stylers": [
            { "visibility": "on" },
            { "color": "#57d2d9" }
          ]
        },
        {
          "elementType":"labels.text.stroke",
          "stylers": [
            { "visibility": "on" },
            { "color": "#ffffff" }
          ]
        }
      ]);
    },
    setProperties : function(properties) {
      if(propertiesOverlay.length > 0 ){
        this.removeAllProperties();
      }
      propertiesBounds = new google.maps.LatLngBounds();
      for (var i = 0; i < properties.length; i++) {
        propertiesBounds.union(this.addProperty(properties[i]));
      }
      if(properties.length > 0) {
        this.recenterMap();
      }
      else {
        this.resetMap();
      }
    },
    recenterMap : function() {
      map.fitBounds(propertiesBounds);
    },
    resetMap : function() {
      map.setCenter(new google.maps.LatLng(0, 0));
      map.setZoom(2);
    },
    addProperty : function(property) {

      var circleOptions = {
        strokeColor: '#fe6b46',
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: '#ff945f',
        fillOpacity: 0.35,
        map: map,
        center: property.center,
        radius: 800
      };
      var overlay = new google.maps.Circle(circleOptions);
      propertiesOverlay.push(overlay);
      return overlay.getBounds();
    },
    removeAllProperties : function() {
      while(propertiesOverlay.length) {
        propertiesOverlay.pop().setMap(null);
      }
    }

  }
};
